import { render, staticRenderFns } from "./acceptNew.vue?vue&type=template&id=686e4e70&lang=html&"
import script from "./acceptNew.vue?vue&type=script&lang=js&"
export * from "./acceptNew.vue?vue&type=script&lang=js&"
import style0 from "./acceptNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "acceptNew.vue"
export default component.exports